import * as React from "react";
import { forwardRef, memo } from "react";
const SvgDesignServices = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M754-584 584-754l57-57q23-23 56.5-23t56.5 23l57 57q23 23 23 56.5T811-641zM120-120v-170l180-180L89-683l189-189 212 213 94-95 170 170-94 94 211 213L683-89 470-301 290-120zm237-407 76-76-48-48-48 47-56-56 47-48-51-50-75 76zm325 325 76-76-51-50-47 47-57-56 48-48-49-48-76 76zm-482 2h56l385-384-57-57-384 385z" })));
const ForwardRef = forwardRef(SvgDesignServices);
const Memo = memo(ForwardRef);
export default Memo;
